module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-de.7cf2301c.mp4";